import { Link } from "react-router-dom";
import moment from "moment";
import { FormattedCategory } from "./utilities/category";
import {PostsFilter, filterPosts} from "./posts_filter";
import { useState } from "react";

export default function PostsHome({ allPosts }) {
  // allPosts.sort((a, b) => (a.occurrence_date < b.occurrence_date) ? 1 : -1);

  const [filter, setFilter] = useState({
    featured_post: false,
    category: "",
    sort: "occurrence",
  });


  return (
    <>
      <PostsFilter params={{
        allPosts: allPosts,
        filter: filter,
        setFilter: setFilter
      }}/>
      <div className="all-posts-wrapper">
        {filterPosts(filter, allPosts).map((post, index) => {
          post.categories = post.category.split(", ");
          let now = moment().format("YYYY-MM-DD");
          let twoWeeksCreated = moment(post.created).add(14, "days").format("YYYY-MM-DD");

          let postClass = 'post'
          if (post.featured_post == 'True') {
            postClass += ' featured-post';
          }
          if (now < twoWeeksCreated) {
            postClass += ' new-post'
          }
          return (
            <Link
              className={postClass}
              key={index}
              to={`/parry_news/post/${post.nid}`}
            >
              <div className="post-image">
                <img
                  src={'https://cms.madebyparry.com' + post.featured_image_preview}
                  alt={post.title}
                />
              </div>
              <div className="post-info">
                <h3>{post.title}</h3>
                <div className="post-tags">
                  <p className="post-date">{moment(post.occurrence_date).fromNow()}</p>
                  <div className="post-categories">
                    {post.categories.length > 0 ? (
                      post.categories.map((category, index) => {
                        return <FormattedCategory category={category} key={index} />;
                      })
                    ) : (
                      ""
                    )}
                  </div>
                </div>
              </div>
            </Link>
          );
        })}
      </div>
    </>
  );
}
